import {CardDeckInput} from "./components/card-deck/card-deck";
import {ChatInput} from "./components/chat-input/chat-input";
import {DateInput} from "./components/date-input/date-input";
import {GenderButtons} from "./components/gender/gender";
import {PlacesInput} from "./components/places-input/places-input";
import {TimeInput} from "./components/time-input/time-input";
import {ContinueButton} from "./components/continue-button/continue-button";
import {BlurText} from "./components/blur-text/blur-text";

const answers = [
  {
    message: [
      "Welcome to our chat. We will reveal your future through the Tarots.",
    ],
    delay: 1300,
    sendNext: true,
  },
  {
    message: [
      "We’re experienced psychics from Himalayas and we can help you to get the most accurate reading.",
    ],
    delay: 3000,
    sendNext: true,
  },
  {
    message: [
      "To make the reading more accurate, we need to feel your energy.",
    ],
    delay: 1300,
    sendNext: true,
  },
  {
    message: [<ChatInput title="What’s your name?" />],
    delay: 1000,
  },
  {
    message: [
      <CardDeckInput title="Without further delay, we will ask you to draw the first card." />,
    ],
    delay: 1000,
  },
  {
    message: [
      <GenderButtons
        title="This first card is full of promises! It symbolizes a new beginning, emerging opportunities. Trust in your potential.
Could you tell us a little more about yourself, you are:"
      />,
    ],
  },
  {
    message: [<DateInput title="And what is your date of birth?" />],
  },
  {
    message: [
      "Thank you for this valuable information. ${name}, сontinuing to answer my questions, you confirm that you accept the ",
      <a href="https://zodiaq.vip/terms.html">Terms of Use</a>,
      " and ",
      <a href="https://zodiaq.vip/privacy.html">Privacy Policy</a>,
      " as well as receiving my partner offers.",
    ],
    delay: 3000,
    sendNext: true,
  },
  {
    message: [<CardDeckInput title="Draw your second card now:" />],
  },
  {
    message: [
      <p>
        This second card emphasizes the importance of relationships and
        emotional decisions. Listen to your heart, but also let your intuition
        guide you.
      </p>,
      <PlacesInput title="May we know where you were born?" />,
    ],
  },
  {
    message: [<TimeInput title="And what time were you born?" />],
  },
  {
    message: [
      "Your astrological sign, ${zodiacSign}, is known for its ability to adapt to changes, which is an exceptional quality. However, the last card from the Astral Tarot that you drew, ${The Moon}, indicates a specific challenge.",
    ],
    sendNext: true,
    delay: 3000,
  },
  {
    message: [
      <p>
        This card seems to contradict the nature of your astrological sign. The
        third card should tell us more…
      </p>,
    ],
    sendNext: true,
    delay: 1500,
  },
  {
    message: [<CardDeckInput title="Draw your third and final card:" />],
  },
  {
    message: [
      "This last card slightly disrupts your previous two draws. This case is unique and no more than 5% of ${zodiaqSign} have such a case. It is probably a sign of",
      <BlurText></BlurText>,
      <ContinueButton></ContinueButton>
    ],
  },
];

export { answers };
